import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: ':not(jd-grid)[grid],jd-grid',
})
export class JdGridDirective {
  @HostBinding('class.jd-grid') _cdGridClass = true;

  constructor() {
  }
}
